import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const rupturaDasRaizes: TechniqueDefinition = {
  id: "ruptura_das_raizes",
  name: "Ruptura das Raízes",
  description:
    "Roots burst from the ground in an area, dealing immediate technique damage.",
  family: "elemental_ninjutsu",
  proficiency: "ninjutsu",
  targeting: "point_area",
  behavior: { kind: "damage" },
  levels: {
    1: {
      chakraCost: 26,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 12,
      attackCoefficient: 1.05,
      radius: 60,
    },
    2: {
      chakraCost: 27,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 13,
      attackCoefficient: 1.09,
      radius: 62,
    },
    3: {
      chakraCost: 28,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 14,
      attackCoefficient: 1.14,
      radius: 64,
    },
    4: {
      chakraCost: 29,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 15,
      attackCoefficient: 1.18,
      radius: 66,
    },
    5: {
      chakraCost: 30,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 16,
      attackCoefficient: 1.23,
      radius: 68,
    },
    6: {
      chakraCost: 30,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 17,
      attackCoefficient: 1.27,
      radius: 70,
    },
    7: {
      chakraCost: 31,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 18,
      attackCoefficient: 1.32,
      radius: 72,
    },
    8: {
      chakraCost: 32,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 20,
      attackCoefficient: 1.36,
      radius: 74,
    },
    9: {
      chakraCost: 33,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 21,
      attackCoefficient: 1.41,
      radius: 76,
    },
    10: {
      chakraCost: 34,
      cooldownMs: 8_000,
      range: 190,
      maxTargets: 4,
      power: 22,
      attackCoefficient: 1.45,
      radius: 78,
    },
  },
  visual: {
    effectId: 230,
    castEffectId: null,
    areaImpactEffectId: 230,
    impactEffectId: null,
  },
};
